"use client";

import { useSyncExternalStore } from "react";
import { Award } from "lucide-react";
import { getAcademyTotalPoints, getAcademyCompletedCount } from "@/lib/academy/progress-store";

/** Kein echtes externes Aenderungs-Event zum Abonnieren noetig (kein Cross-Tab-Live-Sync
 * fuer Phase 1) - `useSyncExternalStore` wird hier ausschliesslich genutzt, um
 * localStorage sicher (ohne Hydration-Mismatch) zu lesen: der Server-Snapshot liefert 0
 * (identisch zum ersten Client-Render vor der Hydration), der echte Wert erscheint erst
 * danach. Leerer no-op-Subscribe reicht, da sich der Wert nur durch eigene Nutzer-Aktion
 * auf DIESER Seite aendert (Quiz-Abschluss loest ohnehin einen Re-Render der Seite aus). */
function subscribe(): () => void {
  return () => {};
}

/** Punkteanzeige auf der Akademie-Uebersicht (backlog.md -> [Punkt 34]). Zeigt bei 0
 * Punkten nichts an, statt eine demotivierende "0 Punkte"-Anzeige direkt beim ersten
 * Besuch. */
export function AcademyPointsBadge() {
  const points = useSyncExternalStore(subscribe, getAcademyTotalPoints, () => 0);
  const completed = useSyncExternalStore(subscribe, getAcademyCompletedCount, () => 0);

  if (!points) return null;

  return (
    <div className="inline-flex items-center gap-2 rounded-full border border-gold/40 bg-primary px-4 py-1.5 shadow-sm">
      <Award className="h-4 w-4 text-gold" aria-hidden="true" />
      <span className="text-sm font-medium text-primary-foreground">
        {points} Punkte · {completed} {completed === 1 ? "Test" : "Tests"} abgeschlossen
      </span>
    </div>
  );
}
